import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogCusto = ({ initial, onClose, ...props }) => {
    const validationSchema = yup.object({
        designacao: yup.string().required('O campo é obrigatório'),
        tipo: yup.number().required('O campo é obrigatório'),
        fabricante: yup.string().when('tipo', ([value], schema) => (value == 1 ? schema.required('O campo é obrigatório') : schema)),
        unidade: yup.string().when('tipo', ([value], schema) => (value == 1 ? schema.required('O campo é obrigatório') : schema)),
        temValor: yup.boolean().required('O campo é obrigatório'),
        quantidade: yup.number().when('tipo', ([value], schema) => (value == 1 ? schema.min(0, 'O valor não pode ser menor que 0').required('O campo é obrigatório') : schema)),
        valor: yup.number().when('temValor', ([value], schema) => (value == 1 ? schema.required('O campo é obrigatório') : schema))
    });
    const formik = useFormik({
        initialValues: initial,
        validationSchema: validationSchema,
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    // Formik fix dialog reuse
    useEffect(() => {
        formik.resetForm();
        if (initial) {
            formik.setValues(initial);
        }
    }, [initial]);
    console.log(formik);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Custo</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Designação *' name='designacao' defaultValue={formik?.values?.designacao} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.tipo && Boolean(formik.errors.tipo)} helperText={formik.touched.tipo && formik.errors.tipo}/>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <TextField label='Tipo *' type='number' name='tipo' value={formik.values?.tipo} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.tipo && Boolean(formik.errors.tipo)} helperText={formik.touched.tipo && formik.errors.tipo} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {[
            { id: 1, name: 'Produto' },
            { id: 2, name: 'Serviço' }
        ].map(x => (<MenuItem value={x.id} key={x.id}>
                    {x.name}
                  </MenuItem>))}
              </TextField>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <TextField label='O custo tem valor associado? *' name='temValor' value={formik.values?.temValor} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.temValor && Boolean(formik.errors.temValor)} helperText={formik.touched.temValor && formik.errors.temValor} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {[
            { id: true, name: 'Sim' },
            { id: false, name: 'Não' }
        ].map(x => (<MenuItem value={Number(x.id)} key={Number(x.id)}>
                    {x.name}
                  </MenuItem>))}
              </TextField>
            </Grid>
          </Grid>
          {formik.values?.tipo == 1 && (<Grid container spacing={2}>
              <Grid lg={12} md={12} xs={12}>
                <TextField label='Fabricante *' name='fabricante' value={formik?.values?.fabricante} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.fabricante && Boolean(formik.errors.fabricante)} helperText={formik.touched.fabricante && formik.errors.fabricante}/>
              </Grid>
              <Grid lg={6} md={6} xs={6}>
                <TextField label='Unidade *' name='unidade' defaultValue={formik.values?.unidade} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.unidade && Boolean(formik.errors.unidade)} helperText={formik.touched.unidade && formik.errors.unidade} select>
                  <MenuItem value={undefined} disabled></MenuItem>
                  {[
                { id: 'un', name: 'Unidade (un)' },
                { id: 'mts', name: 'Metros (mt)' }
            ].map(x => (<MenuItem value={x.id} key={x.id}>
                      {x.name}
                    </MenuItem>))}
                </TextField>
              </Grid>
              <Grid lg={6} md={6} xs={6}>
                <TextField label='Quantidade *' type='number' name='quantidade' value={formik.values?.quantidade} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.quantidade && Boolean(formik.errors.quantidade)} helperText={formik.touched.quantidade && formik.errors.quantidade}/>
              </Grid>
            </Grid>)}
          {formik.values?.temValor ? (<Grid container spacing={2}>
              <Grid lg={12} md={12} xs={12}>
                <TextField label='PVP *' name='valor' value={formik?.values?.valor} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.valor && Boolean(formik.errors.valor)} helperText={formik.touched.valor && formik.errors.valor}/>
              </Grid>
            </Grid>) : null}
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogCusto;
